export default __webpack_public_path__ + "static/media/Montserrat-Bold.2c155811.ttf";